import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { updateSearch } from 'util/shared';

/**
 * Hook that strips both `eh-model` and `date` query parameters from the URL.
 * Used when navigating away from EquityHub to other pages.
 */
const useStripEhQueryParams = () => {
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    setSearchParams(updateSearch({ 'eh-model': undefined, date: undefined }));
  }, [setSearchParams]);
};

export default useStripEhQueryParams;
